import AuthenticationPage from "./Authentication/Authentication";
import HomePage from "./Home/Home";
import MapPage from "./Map/Map";
import NodFoundPage from "./NotFound/NotFound";
import MyMapPage from "./MyMap/MyMap";
import UsersList from "./Users/Users"
import ActivationPage from "./Activation/Activation"

export const Home = HomePage;

export const Map = MapPage;

export const Auth = AuthenticationPage;

export const NotFound = NodFoundPage;

export const MyMap = MyMapPage;

export const Users = UsersList;

export const Activation = ActivationPage;
